import { log } from '@/logger/logger';
import { getAxiosInstance } from '@/services/axiosConfig';
import { Model } from '@/types/nodes/model';

const logger = log.getLogger('replicate.api');
const axiosInstance = getAxiosInstance();

export const getReplicateModelVersionParams = async (modelToFetch: Model) => {
  try {
    const res = await axiosInstance.get<{ openapi_schema: Record<string, unknown> }>(
      `/v1/models/replicate/${modelToFetch.name}/${modelToFetch.version}`,
    );
    return res.data;
  } catch (e) {
    logger.error('Could not get version params', e);
  }
};

export const getReplicateModelVersionByName = async (replicateModelId: string) => {
  try {
    const res = await axiosInstance.get<{
      description: string;
      cover_image_url: string;
      latest_version: { id: string };
    }>(`/v1/models/replicate/${replicateModelId}`);

    return res.data;
  } catch (e) {
    logger.error('Could not get replicate model version by name', e);
  }
};
